<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" custom-class="export-dialog">
    <div v-if="!startTime && !endTime">您未选择时间段，是否确认导出全部查询结果？</div>
    <div v-else>
      <div class="text-c font-size16 mb-5">是否确认导出以下时段的查询结果？</div>
      <div class="text-c font-size14">
        开始时间：
        <span class="font-orange">{{ startTime }}</span>
      </div>
      <div class="text-c font-size14">
        结束时间：
        <span class="font-orange">{{ endTime }}</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="exportSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import axios from '@/api/axiosNew';
import { WUYI } from '@/api/common';
import { mapState } from 'vuex';
export default {
  name: 'ExportList',
  props: {
    exportData: {
      type: Object
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    getExportData() {
      return this.exportData;
    },
    startTime() {
      if (this.getExportData.sDate) {
        if (typeof this.getExportData.sDate == 'number') {
          return WUYI.timeFormat(this.getExportData.sDate) + ' ' + WUYI.formatDate(this.getExportData.sDate);
        } else {
          return this.getExportData.sDate;
        }
      } else {
        return '';
      }
    },
    endTime() {
      if (this.getExportData.eDate) {
        if (typeof this.getExportData.eDate == 'number') {
          return WUYI.timeFormat(this.getExportData.eDate) + ' ' + WUYI.formatDate(this.getExportData.eDate);
        } else {
          return this.getExportData.eDate;
        }
      } else {
        return '';
      }
    }
  },
  methods: {
    showExportBox() {
      this.dialogVisible = true;
    },
    exportSubmit() {
      axios.post(this.getExportData.exportUrl, { ...this.getExportData.opts }).then(res => {
        this.$message.success('提交成功，请稍后在“下载管理”中查看');
        this.dialogVisible = false;
      });
    }
  }
};
</script>

<style>
.export-dialog {
  width: 480px;
}
.child {
  display: inline-block;
}
</style>
